import ChangeLanguageModal from "./ChangeLanguageModal";
import ChangeCharacterModal from "./ChangeCharacterModal";
import SessionStartModal from "./SessionStartModal";
import { useModalStore, ModalType } from "@/store/useModalStore";
import ChangeVoiceModal from "./ChangeVoiceModal";
import MicPermissionModal from "./MicPermissionModal";
import MicSilenceTestModal from "./MicSilenceTestModal";
import { useNavigate } from "react-router-dom";

export default function ModalRoot() {
  const { modal, modalProps, closeModal } = useModalStore();
  const navigate = useNavigate();

  const navigateToLessons = () => {
    navigate("/lessons");
  };

  if (!modal) return null;

  switch (modal) {
    // onClose is spread after modalProps on purpose: closing this screen means
    // leaving the lesson, and no caller may substitute a plain dismiss.
    case ModalType.SESSION_START:
      return (
        <SessionStartModal
          isOpen={true}
          {...modalProps}
          onClose={navigateToLessons}
        />
      );
    case ModalType.CHANGE_LANGUAGE:
      return (
        <ChangeLanguageModal
          isOpen={true}
          {...modalProps}
          onClose={closeModal}
        />
      );
    case ModalType.CHANGE_CHARACTER:
      return (
        <ChangeCharacterModal
          isOpen={true}
          {...modalProps}
          onClose={closeModal}
        />
      );
    case ModalType.CHANGE_VOICE:
      return (
        <ChangeVoiceModal isOpen={true} {...modalProps} onClose={closeModal} />
      );
    case ModalType.MIC_PERMISSION:
      return <MicPermissionModal isOpen={true} onRetry={modalProps?.onRetry} />;
    case ModalType.MIC_SILENCE_TEST:
      return (
        <MicSilenceTestModal
          isOpen={true}
          onClose={closeModal}
          onDeviceConfirmed={modalProps?.onDeviceConfirmed}
        />
      );
    default:
      return null;
  }
}
